module.exports = __webpack_public_path__ + "img/investment_1.5cfdf98f.jpg";